import React, { useEffect } from "react";
import { redirectToPlans } from "./plansNavigation";

const PlansRedirect: React.FC = () => {
    useEffect(() => {
        redirectToPlans();
    }, []);

    return null;
};

export default PlansRedirect;
